<template>
  <nav class="nav col">
    <div class="d-flex flex-column w-100 h-100 justify-content-between">
      <div class="nav__top">
        <div class="nav__user">
          <b-dropdown v-if="patient" id="patient-select" class="ml-0" :text="patient.name">
            <template #button-content>
              <img class="d-inline-block mr-1 mb-3" src="~@/assets/images/user_profile.svg" alt="">
              <p class="text-left d-inline-block" v-html="getPatientFormattedName(patient.name)"/>
            </template>
            <div class="clearfix" v-for="(patientItem,key) in user.patients">
              <b-dropdown-item @click="changePatient(patientItem)">
                <template #default>
                  <p class="text-left patient-item mb-0 d-inline-block"
                     v-html="getPatientFormattedName(patientItem.name)"/>
                  <img class="d-inline-block float-right" v-if="patient.id === patientItem.id"
                       src="~@/assets/images/tick_blue_success.svg" alt="">
                </template>
              </b-dropdown-item>

              <b-dropdown-divider v-if="key !== Object.keys(user.patients).length - 1"></b-dropdown-divider>
            </div>

          </b-dropdown>
          <router-link class="nav__settings mb-2" :to="{name:'profile.info'}"></router-link>
        </div>
        <b-dropdown id="ddown1" :text="$t('buttons.book')">
          <b-dropdown-item>
            <router-link class="" :to="{name:'profile.order.find-doctor'}">
              {{ $t('buttons.book_consultation') }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link class="" :to="{name:'profile.order.find-diagnostic'}">
              {{ $t('buttons.book_diagnostic') }}
            </router-link>
          </b-dropdown-item>
        </b-dropdown>
        <router-link class="nav__link" :to="{name:'profile.visits.current'}">
          <svg class="nav__link-icon" width="12" height="13" viewBox="0 0 12 13" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.3032 2.07159C11.1418 1.89539 10.9503 1.80727 10.7293 1.80727H9.91311V1.13951C9.91311 0.833525 9.81311 0.571513 9.61332 0.353572C9.41341 0.135631 9.17333 0.0266113 8.89266 0.0266113H8.48463C8.20398 0.0266113 7.9638 0.135631 7.76398 0.353596C7.5641 0.571513 7.46419 0.833549 7.46419 1.13953V1.80729H5.01552V1.13953C5.01552 0.833549 4.91557 0.571537 4.71573 0.353596C4.51594 0.135631 4.27574 0.0266113 3.99509 0.0266113H3.58699C3.30641 0.0266113 3.06619 0.135631 2.86635 0.353596C2.66656 0.571513 2.56658 0.833549 2.56658 1.13953V1.80729H1.75039C1.52926 1.80729 1.33798 1.89541 1.17643 2.07162C1.01487 2.2478 0.934082 2.45654 0.934082 2.69765V11.6008C0.934082 11.8417 0.94199 12.144 1.10355 12.3203C1.26508 12.4964 1.52924 12.491 1.75039 12.491H10.7291C10.9502 12.491 11.2157 12.4853 11.377 12.3092C11.5386 12.1329 11.5454 11.8417 11.5454 11.6008V2.69762C11.5454 2.45644 11.4647 2.2478 11.3032 2.07159ZM8.28057 1.13961C8.28057 1.07463 8.29953 1.02126 8.33775 0.979623C8.37596 0.93794 8.42488 0.917062 8.48449 0.917062H8.89252C8.95216 0.917062 9.00092 0.937867 9.03927 0.979623C9.07751 1.02133 9.0966 1.07471 9.0966 1.13961V3.14274C9.0966 3.20769 9.07751 3.26097 9.03927 3.30272C9.0009 3.34436 8.95216 3.36528 8.89252 3.36528H8.48449C8.42488 3.36528 8.37596 3.34445 8.33775 3.30272C8.29953 3.26094 8.28057 3.20769 8.28057 3.14274V1.13961ZM3.38295 1.13961C3.38295 1.07463 3.40205 1.02126 3.44031 0.979623C3.4786 0.93794 3.52745 0.917062 3.58699 0.917062H3.99509C4.05466 0.917062 4.1036 0.937867 4.14177 0.979623C4.17999 1.02133 4.19917 1.07471 4.19917 1.13961V3.14274C4.19917 3.20769 4.18007 3.26104 4.14177 3.30272C4.10351 3.34436 4.05466 3.36528 3.99509 3.36528H3.58699C3.52745 3.36528 3.47853 3.34445 3.44031 3.30272C3.40214 3.26094 3.38295 3.20769 3.38295 3.14274V1.13961ZM10.3652 11.264H2.09453V4.47821H10.3652V11.264Z"
                fill="#0A4766"/>
          </svg>
          {{ $t('nav.records') }}
          <template v-if="visitCurrentCount > 0">
            <div class="nav__badges">{{ visitCurrentCount }}</div>
          </template>
        </router-link>
        <router-link class="nav__link" :to="{name:'profile.visits.past.consultations'}">
          <svg class="nav__link-icon" width="12" height="13" viewBox="0 0 12 13" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.00837 1.49724H2.11313V11.2715H10.3665V3.94081H8.00837V1.49724ZM0.934082 0.881457C0.934082 0.546688 1.1976 0.275452 1.52302 0.275452H8.59789L11.5455 3.32992V11.8781C11.5461 11.9584 11.5313 12.0379 11.5022 12.1122C11.4731 12.1866 11.4301 12.2542 11.3758 12.3114C11.3214 12.3685 11.2567 12.414 11.1854 12.4452C11.1141 12.4764 11.0375 12.4927 10.9601 12.4933H1.51948C1.36466 12.4922 1.21647 12.428 1.10694 12.3146C0.997407 12.2012 0.935317 12.0477 0.934082 11.8873V0.881457ZM5.65027 5.77349V3.94081H6.82932V5.77349H8.59789V6.99527H6.82932V8.82795H5.65027V6.99527H3.8817V5.77349H5.65027Z"
                fill="#0A4766"/>
          </svg>
          {{ $t('nav.visits') }}
          <template v-if="consultationsPastCount > 0">
            <div class="nav__badges">{{ consultationsPastCount }}</div>
          </template>
        </router-link>
        <router-link class="nav__link" :to="{name:'profile.visits.past.diagnostics'}">
          <svg class="nav__link-icon" width="15" height="14" viewBox="0 0 15 14" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.94227 0.822981C7.83675 0.824352 7.73437 0.859031 7.64974 0.922064C7.56511 0.985097 7.50257 1.07326 7.47103 1.17396L5.36808 7.90421L4.78539 6.57458V6.5736C4.37785 5.64329 2.99489 5.60748 2.54067 6.51592L2.38424 6.82975H1.44178C1.37544 6.82881 1.30959 6.84107 1.24804 6.8658C1.18648 6.89054 1.13046 6.92726 1.08322 6.97383C1.03598 7.02041 0.998472 7.07591 0.972869 7.13711C0.947267 7.1983 0.934082 7.26398 0.934082 7.33032C0.934082 7.39665 0.947267 7.46233 0.972869 7.52353C0.998472 7.58473 1.03598 7.64022 1.08322 7.6868C1.13046 7.73337 1.18648 7.7701 1.24804 7.79483C1.30959 7.81957 1.37544 7.83182 1.44178 7.83088H2.69319C2.78615 7.83089 2.87728 7.80501 2.95637 7.75614C3.03545 7.70727 3.09937 7.63735 3.14096 7.5542L3.43621 6.96369C3.5425 6.75111 3.77291 6.75718 3.86834 6.97542L4.98777 9.533C5.02858 9.62651 5.097 9.70531 5.18384 9.75886C5.27069 9.8124 5.37183 9.83814 5.47371 9.83261C5.57559 9.82708 5.67335 9.79055 5.75389 9.72791C5.83443 9.66528 5.89391 9.57954 5.92437 9.48216L7.66363 3.91827L8.45163 13.3791C8.461 13.4909 8.50762 13.5963 8.58403 13.6784C8.66044 13.7605 8.76221 13.8145 8.87301 13.8319C8.98382 13.8493 9.09724 13.8289 9.1951 13.7741C9.29296 13.7193 9.36958 13.6332 9.41268 13.5297L11.7864 7.83088H13.0936C13.2669 8.12903 13.586 8.33145 13.9559 8.33145C14.509 8.33145 14.957 7.88344 14.957 7.33032C14.957 6.77719 14.509 6.32919 13.9559 6.32919C13.586 6.32919 13.2669 6.5316 13.0936 6.82975H11.4531C11.3542 6.82968 11.2575 6.85889 11.1752 6.91369C11.0929 6.9685 11.0287 7.04645 10.9906 7.13772L9.27776 11.2478L8.44772 1.28151C8.43709 1.15532 8.37902 1.03785 8.28523 0.95277C8.19144 0.867687 8.06889 0.821309 7.94227 0.822981Z"
                fill="#0A4766"/>
          </svg>
          {{ $t('visits.diagnostics') }}
          <template v-if="diagnosticsPastCount > 0">
            <div class="nav__badges">{{ diagnosticsPastCount }}</div>
          </template>
        </router-link>
        <router-link class="nav__link" :to="{name:'profile.analyzes'}">
          <svg class="nav__link-icon" width="14" height="14" viewBox="0 0 14 14" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.67714 0.663941C9.57261 0.664173 9.47051 0.695549 9.38388 0.754064C9.29726 0.81258 9.23003 0.895581 9.19079 0.992473C9.15155 1.08936 9.14207 1.19575 9.16356 1.29806C9.18506 1.40036 9.23654 1.49394 9.31146 1.56685L9.46143 1.71682L1.56022 9.61802C0.725368 10.4529 0.725368 11.8226 1.56022 12.6575L1.7143 12.8116H1.7934C2.63371 13.4521 3.83339 13.4238 4.5997 12.6575L12.5009 4.7563L12.6509 4.90627C12.6993 4.95674 12.7574 4.99704 12.8216 5.0248C12.8858 5.05256 12.955 5.06722 13.0249 5.06793C13.0949 5.06865 13.1643 5.05539 13.2291 5.02894C13.2939 5.00249 13.3527 4.96338 13.4022 4.91391C13.4517 4.86443 13.4908 4.80557 13.5172 4.74079C13.5437 4.67601 13.5569 4.60661 13.5562 4.53664C13.5555 4.46667 13.5409 4.39754 13.5131 4.33331C13.4853 4.26908 13.445 4.21104 13.3946 4.16258L11.7305 2.49852L10.0552 0.823157C10.006 0.772652 9.94724 0.732534 9.88231 0.705183C9.81737 0.677833 9.7476 0.663808 9.67714 0.663941ZM10.2051 2.46051L10.9868 3.24221L11.7572 4.01261L9.8456 5.92422L6.74141 5.92422L10.2051 2.46051Z"
                fill="#0A4766"/>
          </svg>
          {{ $t('nav.analyzes') }}
          <template v-if="analyzesCount > 0">
            <div class="nav__badges">{{ analyzesCount }}</div>
          </template>
        </router-link>
        <router-link v-if="personalDoctorId !== null"
                     class="nav__link"
                     :to="{name:'profile.order.choose-doctor-time-table',
                     query:{my_doctor: 1, doctor_id: personalDoctorId, patient_id: patient.id}}">
          <svg class="nav__link-icon" width="12" height="14" viewBox="0 0 12 14" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.76348 9.92279C9.66614 10.2819 11.0144 11.2017 11.0144 12.2791V13.5391H0.934082V12.2791C0.934082 11.2017 2.28232 10.2819 4.18498 9.92279L5.97423 12.9091L7.76348 9.92279ZM3.45416 4.71883H8.49431V5.97887C8.49431 6.64723 8.2288 7.28823 7.75619 7.76083C7.28359 8.23344 6.6426 8.49894 5.97423 8.49894C5.30587 8.49894 4.66487 8.23344 4.19227 7.76083C3.71966 7.28823 3.45416 6.64723 3.45416 5.97887V4.71883ZM3.45416 4.08881L3.71246 1.50574C3.74396 1.18443 4.01487 0.938721 4.34248 0.938721H7.61228C7.93359 0.938721 8.2045 1.18443 8.236 1.50574L8.49431 4.08881H3.45416ZM5.97423 1.56874H5.34421V2.19876H4.71419V2.82878H5.34421V3.4588H5.97423V2.82878H6.60425V2.19876H5.97423V1.56874Z"
                fill="#0A4766"/>
          </svg>

          {{ $t('nav.my_doctor') }}
        </router-link>
        <b-link class="nav__link no-icon" @click="logout">
          {{ $t('nav.exit') }}
          <div class="nav__badges">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1"
                 x="0px" y="0px" width="14px" height="14px" viewBox="0 0 492.5 492.5"
                 style="enable-background:new 0 0 492.5 492.5;" xml:space="preserve">
                            <g>
                                <path
                                    d="M184.646,0v21.72H99.704v433.358h31.403V53.123h53.539V492.5l208.15-37.422v-61.235V37.5L184.646,0z M222.938,263.129   c-6.997,0-12.67-7.381-12.67-16.486c0-9.104,5.673-16.485,12.67-16.485s12.67,7.381,12.67,16.485   C235.608,255.748,229.935,263.129,222.938,263.129z"
                                    fill="#FFFFFF"/>
                            </g>
                            </svg>
          </div>
        </b-link>
      </div>
      <div class="nav__bottom">
        <router-link class="nav__link" :to="{name:'profile.clinics'}">
          {{ $t('nav.address') }}
        </router-link>

        <a class="link-bottom">
          <img src="~@/assets/images/ic-phone.svg" alt="Круглосуточная горячая линия">
          <div class="d-flex flex-column">
            <span class="link-bottom-phone">
              <a href="tel:0487300030">+38 (048) 730-00-30</a>
            </span>
            <span class="link-bottom-phone">
              <a href="tel:0963803030">+38 (096) 380-30-30</a>
            </span>
            <span class="link-bottom-phone">
              <a href="tel:0633803030">+38 (063) 380-30-30</a>
            </span>
            <span class="link-bottom-phone">
              <a href="tel:0663803030">+38 (066) 380-30-30</a>
              <span class="small-desc">{{ $t('nav.call') }}</span>
            </span>
          </div>
        </a>

        <router-link class="link-bottom link-bottom-border mobile-install" :to="{name:'mobile-install'}">
          <div class="link-bottom">
            <img src="~@/assets/images/ic-mobile-app.svg" alt="Устанавливайте приложение Odrex">
            <span v-html="$t('nav.install_app')"/>
          </div>
        </router-link>

        <a target="_blank" href="https://odrex.ua">
          <img class="logo" src="~@/assets/images/logo-sidebar-grey.svg" alt="Odrex">
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'navigation',
  computed: {
    ...mapState({
      availableRecordToday: state => state.auth.user.available_record_today,
    }),
    ...mapGetters({
      consultationsPastCount: 'consultationsPastCount',
      diagnosticsPastCount: 'diagnosticsPastCount',
      visitsDiagnostic: 'diagnosticsPast',
      visitsSpecialization: 'consultationsPast',
      visitCurrentCount: 'visitCurrentCount',
      analyzesCount: 'analyzesCount',
      user: 'user',
      patient: 'patient',
      familyDoctorSpecialization: 'familyDoctorSpecialization',
      personalDoctorId: 'personalDoctorId'
    }),
    name() {
      if (this.patient) {
        return this.patient.name;
      }

      return null;
    },
  },
  methods: {
    getPatientFormattedName(name) {
      if (!name) return ''
      let [last_name = null, first_name = null, second_name = null] = name.split(' ');
      return `<span>${last_name} ${first_name}</span> <br> <span>${second_name}</span>`
    },
    changePatient(patient) {
      this.$store.dispatch('setPatient', patient).then(() => window.location.reload(true))
    },
    logout() {
      this.$store.dispatch('logout')
    },
    fetchPatientData() {
      if (this.patient) {
        this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']})
      }


    }
  },
  mounted() {
    this.fetchPatientData()
  },
}
</script>
